const COOKIE_NAME = 'mhj-ring-size'
const MAX_AGE_SECONDS = 60 * 60 * 24 * 30

export function useRememberedRingSize() {
  // Plain encode/decode: the JSON defaults quote numeric sizes like "5", so they never match on read.
  const cookie = useCookie<string | null>(COOKIE_NAME, {
    maxAge: MAX_AGE_SECONDS,
    sameSite: 'lax',
    encode: encodeURIComponent,
    decode: decodeURIComponent,
  })

  // Shared across the pdp and quickview stores; initialised once from the cookie.
  const rememberedRingSize = useState<string | null>('remembered-ring-size', () => cookie.value || null)
  // useCookie syncs its ref when another tab writes the cookie; mirror that into the shared state.
  watch(cookie, (value) => {
    rememberedRingSize.value = value || null
  })

  const remember = (size: string) => {
    rememberedRingSize.value = size
    cookie.value = size
  }

  return { rememberedRingSize: readonly(rememberedRingSize), remember }
}
